import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyMatch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 132.97,
			cy: 128.06,
			r: 119.84,
			fill: "var(--primary)",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 205.16,
			height: 161.42,
			x: 66.19,
			y: 90.61,
			fill: "var(--foreground)",
			rx: 18.77,
			ry: 18.77,
			transform: "rotate(-80.93 168.77 171.32)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 157.96,
			height: 201.7,
			x: 81.82,
			y: 69.19,
			fill: "var(--card)",
			rx: 17.04,
			ry: 17.04,
			transform: "rotate(9.07 160.8 170.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M208.76 281.35q-1.47 0-2.97-.24L83.46 261.58c-4.96-.8-9.3-3.46-12.24-7.52a18.7 18.7 0 0 1-3.34-13.98L94.31 74.56a18.8 18.8 0 0 1 21.5-15.58l122.33 19.53c4.95.8 9.3 3.46 12.24 7.52a18.7 18.7 0 0 1 3.33 13.98l-26.43 165.52a18.8 18.8 0 0 1-18.52 15.82m-2.43-3.66a15.33 15.33 0 0 0 17.53-12.7L250.3 99.46a15.2 15.2 0 0 0-2.72-11.4 15.2 15.2 0 0 0-9.98-6.13L115.26 62.4a15.3 15.3 0 0 0-17.53 12.7L71.3 240.63a15.2 15.2 0 0 0 2.72 11.4 15.2 15.2 0 0 0 9.98 6.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m211 70.82-20.66-3.3.13-.82a13 13 0 1 0-25.69-4.1l-.13.82-20.66-3.3a6.85 6.85 0 0 0-2.16 13.52l67 10.7A6.85 6.85 0 0 0 211 70.83Zm-35.1-13.7a3.1 3.1 0 1 1 6.1.98 3.1 3.1 0 0 1-6.1-.98"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 139,
			height: 181.09,
			x: 91.04,
			y: 81.13,
			fill: "var(--card)",
			rx: 9.52,
			ry: 9.52,
			transform: "rotate(9.07 160.53 171.67)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M207.01 272.4q-.9 0-1.8-.15L86.77 253.34a11.2 11.2 0 0 1-7.34-4.51 11.2 11.2 0 0 1-2-8.37l25.55-160.03a11.26 11.26 0 0 1 12.88-9.34l118.47 18.92c2.96.47 5.57 2.07 7.33 4.5a11.2 11.2 0 0 1 2 8.38L218.1 262.92a11.2 11.2 0 0 1-4.51 7.33 11 11 0 0 1-6.58 2.15m-92.93-198a7.8 7.8 0 0 0-7.69 6.56L80.84 241a7.7 7.7 0 0 0 1.38 5.8 7.7 7.7 0 0 0 5.08 3.12l118.46 18.91a7.7 7.7 0 0 0 5.8-1.38 7.7 7.7 0 0 0 3.12-5.08l25.55-160.03a7.7 7.7 0 0 0-1.39-5.8 7.7 7.7 0 0 0-5.07-3.11L115.3 74.5q-.63-.1-1.23-.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m221.2 95.42-.23-.02-40-6.39a7.32 7.32 0 0 1-14.13-2.26l-39.98-6.38a1.45 1.45 0 0 1-1.2-1.66l1.63-10.23c.13-.79.87-1.32 1.66-1.2l94.1 15.02a1.45 1.45 0 0 1 1.21 1.67l-1.63 10.22a1.45 1.45 0 0 1-1.43 1.23m-41.28-9.5.23.02 39.84 6.36 1.17-7.35-91.23-14.57-1.17 7.35 39.84 6.36c.8.13 1.33.88 1.2 1.67a4.4 4.4 0 0 0 8.68 1.38 1.46 1.46 0 0 1 1.44-1.22m-43.7 5.74-1.1-.33-1.6 10 .75.29a10.67 10.67 0 0 1 4.37 16.62l-.5.63 6.3 7.9.79-.81a20.76 20.76 0 0 0-9.02-34.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M135 121.13a10.68 10.68 0 0 1-15.2-11.28c.78-4.9 4.94-8.67 9.89-8.96l.8-.05 1.6-9.99-1.15-.04a20.76 20.76 0 0 0-21.07 17.46 20.75 20.75 0 0 0 31.19 21l.97-.58-6.3-7.92zm-32.73 36.89 15.4 2.46-3.97 24.84-15.4-2.46zm28.13-12.49 15.4 2.46-6.61 41.4-15.4-2.45zm24.34 20.87 15.4 2.46-3.97 24.84-15.4-2.45zm29.71-22.33 15.4 2.45-8.19 51.25-15.4-2.46zm20.31 30.32 15.4 2.46-3.97 24.84-15.4-2.46z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m170.25 101.86 59.29 9.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m229.55 112.6-.2-.01-59.3-9.47a1.27 1.27 0 1 1 .4-2.52l59.3 9.47a1.27 1.27 0 0 1-.2 2.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m168.69 111.6 59.3 9.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m227.99 122.34-.2-.01-59.3-9.47a1.27 1.27 0 1 1 .4-2.52l59.3 9.47a1.27 1.27 0 0 1-.2 2.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m167.14 121.34 59.29 9.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m226.44 132.08-.2-.02-59.3-9.46a1.27 1.27 0 1 1 .4-2.52l59.3 9.47a1.27 1.27 0 0 1-.2 2.53"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m165.58 131.08 59.3 9.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "m224.88 141.82-.2-.02-59.3-9.46a1.27 1.27 0 1 1 .4-2.52l59.3 9.47a1.27 1.27 0 0 1-.2 2.53"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 162.77,
			cy: 100.67,
			r: 2.88,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 161.21,
			cy: 110.41,
			r: 2.88,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 159.66,
			cy: 120.15,
			r: 2.88,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 158.1,
			cy: 129.88,
			r: 2.88,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m103.44 194.79-7.37 46.18 103.59 16.54"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M199.38 259.22 95.8 242.68a1.73 1.73 0 0 1-1.44-1.99l7.37-46.17 3.42.55-7.1 44.46 101.88 16.27z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M107.64 201.4c-.64 0-1.26-.36-1.56-.97l-2.8-5.72-3.76 4.55a1.73 1.73 0 1 1-2.67-2.2l5.48-6.63a1.73 1.73 0 0 1 2.9.34l3.96 8.14a1.73 1.73 0 0 1-1.55 2.49m86.65 62a1.73 1.73 0 0 1-.76-3.28l5.72-2.8-4.56-3.76a1.73 1.73 0 1 1 2.21-2.67l6.62 5.47a1.73 1.73 0 0 1-.34 2.9l-8.13 3.97q-.36.18-.76.18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--card)",
			d: "m110.36 231.43 21.32-8.45 17.08 12.92 20.86-18.61 18.59 7.84 14.81-10.23"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M148.76 237.63q-.57 0-1.05-.35l-16.3-12.34-20.42 8.1-1.27-3.22 21.32-8.45c.56-.22 1.2-.14 1.68.22l15.95 12.07 19.8-17.66a1.7 1.7 0 0 1 1.83-.3l17.7 7.47 14.03-9.7 1.97 2.85-14.8 10.24c-.5.33-1.12.4-1.67.17l-17.57-7.42-20.05 17.88q-.52.44-1.15.44"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 111.36,
			cy: 231.02,
			r: 3.52,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 131.34,
			cy: 223.8,
			r: 3.52,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 148.95,
			cy: 234.7,
			r: 3.52,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 169.87,
			cy: 218.14,
			r: 3.52,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 188.22,
			cy: 224.63,
			r: 3.52,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 201.68,
			cy: 215.37,
			r: 3.52,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 234.91,
			cy: 91.18,
			r: 33.45,
			fill: "var(--foreground)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M234.97 126.1q-1.52 0-3.05-.14a34.95 34.95 0 0 1-31.8-37.76 34.93 34.93 0 0 1 37.77-31.8 34.95 34.95 0 0 1 31.8 37.77 34.7 34.7 0 0 1-12.3 23.72 34.7 34.7 0 0 1-22.42 8.2m-31.93-37.65a32 32 0 0 0 29.13 34.6c8.51.74 16.8-1.9 23.34-7.4a31.8 31.8 0 0 0 11.27-21.73 32 32 0 0 0-29.14-34.6 32 32 0 0 0-34.6 29.13"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 229.56,
			cy: 90.72,
			r: 33.45,
			fill: "var(--card)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M229.59 125.63q-1.5 0-3.01-.13a34.95 34.95 0 0 1-31.8-37.76 34.95 34.95 0 0 1 37.77-31.8 34.95 34.95 0 0 1 31.8 37.77 34.96 34.96 0 0 1-34.76 31.92M197.69 88a32 32 0 0 0 31.9 34.72 32.03 32.03 0 0 0 31.84-29.25 32 32 0 0 0-29.13-34.6A32 32 0 0 0 197.7 88Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--foreground)",
			d: "M218.32 73.41q4.45-5.55 13.25-4.79 8.79.75 12.24 6.98t2.56 16.44q-.89 10.34-5.34 15.88t-13.25 4.79-12.24-6.98-2.56-16.56q.88-10.2 5.34-15.76m17.56 8.42q-1.04-3.35-5.13-3.7c-4.09-.35-4.63.69-5.68 2.77q-1.59 3.13-2.1 9.13-.36 4.05-.1 6.73a8.6 8.6 0 0 0 1.56 4.44q1.32 1.76 4.17 2c2.85.24 3.38-.26 4.44-1.26q1.6-1.5 2.3-4.11c.7-2.61.82-3.95 1.05-6.65q.52-6-.51-9.35m-140-29.56c-.64 0-1.28-.3-1.68-.88-8.85-12.69-11.48-16.23-13.25-18.55a2.06 2.06 0 1 1 3.28-2.5c2.23 2.92 5.35 7.22 13.35 18.69a2.06 2.06 0 0 1-1.7 3.24m10.43-4.4a2.06 2.06 0 0 1-2.05-1.8c-1.7-14-2.29-18.01-2.71-20.69a2.06 2.06 0 1 1 4.07-.64c.43 2.7 1.03 6.77 2.74 20.83a2.06 2.06 0 0 1-2.06 2.3Zm-16.94 13.9q-.34 0-.68-.12c-15.56-5.35-20.03-6.7-23-7.53a2.06 2.06 0 0 1 1.12-3.97c3.03.85 7.56 2.22 23.23 7.6a2.06 2.06 0 0 1-.67 4.02"
		})
	]
});
export default SvgEmptyMatch;
